export default "__VITE_PUBLIC_ASSET__743f7e6d__"